import { render, staticRenderFns } from "./treasury-kids-result.pug?vue&type=template&id=bc72f38a&scoped=true&functional=true&lang=pug&external"
var script = {}
import style0 from "./treasury-kids-result.scss?vue&type=style&index=0&id=bc72f38a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "bc72f38a",
  null
  
)

export default component.exports